var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "47px",
    viewBox: "0 0 63 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0555556,14.3611111 C13.0555556,12.1991111 14.8102222,10.4444444 16.9722222,10.4444444 C19.1342222,10.4444444 20.8888889,12.1991111 20.8888889,14.3611111 C20.8888889,16.5257222 19.1342222,18.2777778 16.9722222,18.2777778 C14.8102222,18.2777778 13.0555556,16.5257222 13.0555556,14.3611111 Z M36.5555556,15.6666667 L29.9781667,26.1111111 L23.5,20.9933333 L13.0555556,36.5555556 L49.6111111,36.5555556 L36.5555556,15.6666667 Z M57.4444444,5.22222222 L57.4444444,41.7777778 L5.22222222,41.7777778 L5.22222222,5.22222222 L57.4444444,5.22222222 Z M62.6666667,0 L0,0 L0,47 L62.6666667,47 L62.6666667,0 Z",
    id: "Shape",
    fill: "#828282",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.a1a04f5c.svg";
export { ForwardRef as ReactComponent };